import { Routes } from '@angular/router';
import { CreateLibrarySettingComponent } from './views/library-setting/create/create-library-setting.component';
import { ActionTransactionComponent } from './views/action-transaction/action-transaction.component';

export const routes: Routes = [
  {
    path: 'settings',
    title: '設定',
    children: [
      {
        path: 'create-library',
        title: 'HUB・WBS・紐づけレイアウト作成',
        // component: CreateLibrarySettingComponent,
        loadComponent: () =>
          import(
            './views/library-setting/create/create-library-setting.component'
          ).then((m) => m.CreateLibrarySettingComponent),
      },
      {
        path: 'api',
        title: 'API設定',
        loadComponent: () =>
          import('./views/api-setting/api-setting.component').then(
            (m) => m.ApiSettingComponent
          ),
      },
    ],
  },
  {
    path: 'views',
    title: 'データ参照',
    children: [
      {
        path: 'action-transaction',
        title: 'アクショントランザクション',
        // component: ActionTransactionComponent,
        loadComponent: () =>
          import(
            './views/action-transaction/action-transaction.component'
          ).then((m) => m.ActionTransactionComponent),
      },
    ],
  },
  {
    path: '**',
    // redirectTo: 'settings/create-library',
    redirectTo: 'views/action-transaction',
  },
];
